import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "app-header" }

import { ref } from 'vue'
import { useRouter } from "vue-router"
import selectLocale from './component/selectLocale.vue';

import { useCartStore } from "@/store/cartStore"

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
      AndroidApp: any; 
      onNativeResponse: any;
    }
}

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()
const store = useCartStore()

function goHome() {
  store.resetMyCart()
  router.push('/')
}

/* 안드로이드 앱 하이브리드 통신 */
const android_check = ref('')
const font_color = ref('blue')
window.AndroidApp = window.AndroidApp || undefined;
window.onNativeResponse = onNativeResponse;

if (window.AndroidApp) {
  android_check.value = '안드로이드 통신 가능 ^^'
} else {
  android_check.value = '안드로이드 통신 불가능!'
  font_color.value = 'red'
}

const msg = ref('')
async function onNativeResponse(msg_string: string) {
  msg.value = JSON.parse(msg_string)
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            onClick: goHome,
            variant: "text",
            color: "blue-grey-darken-4",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("HOME")
            ]),
            _: 1
          }),
          _createVNode(selectLocale)
        ]),
        _createElementVNode("h2", {
          style: _normalizeStyle({'color': font_color.value, 'text-align': 'center'})
        }, _toDisplayString(android_check.value), 5),
        _createElementVNode("p", null, _toDisplayString(msg.value), 1),
        _createVNode(_component_router_view)
      ])
    ]),
    _: 1
  }))
}
}

})